import type { FaireProductEntity } from "../../entity_types/product";

export const p_sqe8wwg25b: FaireProductEntity = {
  token: "p_sqe8wwg25b",
  type: "product",
  name: "Pink Bloom Flroal Pendant Bow Gold Necklace",
  brandToken: "b_6hzxpxjqta",
  brandName: "Sparkling Extras",
  imageUrl:
    "https://cdn.faire.com/fastly/5036f14550f93e29eb23347075800aa8a8f22e15a7f57d793c972a9ad9da7cc0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4f983c06454c73dcd10ffcb9133204a979b89b4efbaf21f16f3fd197fa9c13b0.jpeg",
    "https://cdn.faire.com/fastly/6d19ab625b24719db3d30599cf69c643093df8b67e387511697dbcfd64e9e462.jpeg",
    "https://cdn.faire.com/fastly/610ad46b47132b199c8c4d4d290ea443c41cebe051f336a1e6f516b398d99a23.jpeg",
  ],
  priceDollars: 6.91,
  description:
    "Material：Titanium steel\nProcessing technology ：Electroplating\nPendant material ：Crystal\nPendant size:17.7*9.6mm\nChain length: 40+5cm\nStyle classification:Personality trend\nColor: 18K Gold",
  tags: [],
  msrpDollars: 11.07,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:31.218Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
